module.exports = __webpack_public_path__ + "img/zu15.25fd39f3.svg";